import axios from 'axios'

const getEnvFile = async (isLocal: boolean) => {
    let env: { [x: string]: string | undefined; TZ?: string | undefined } = {}
    if (isLocal) {
        console.log('process.env: ', process.env)
        env = process.env
    } else {
        const { data } = await axios.get('/booking/config/env-xftless')
        try {
            // Parse the .env file
            const lines = data.split('\n')

            for (const line of lines) {
                const [key, value] = line.split('=')
                if (key && value) {
                    env[key.trim()] = value.trim().replaceAll('"', '')
                }
            }

            env = { ...process.env, ...env } // combine env from the process with the fetched file

            // Now env contains your environment variables
        } catch (err) {
            console.error('Error:', err)
        }
    }
    return env
}

export default getEnvFile
